import { render, staticRenderFns } from "./_DataTableModal.vue?vue&type=template&id=64959cf2&"
import script from "./_DataTableModal.vue?vue&type=script&lang=js&"
export * from "./_DataTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports